import * as React from 'react';
//style
import "../styles/JourneyRightSection/responsive.css";

import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
// //img
import CreditScoreIcon from '../pages/Navbar/image/CreditScoreIcons.png';

//micro comp
import ExistingLoansPage from '../pages/BuroRecords/ExistingLoans';
import MyApplicationsPage from '../pages/BuroRecords/MyApplications';
import ExclusiveOffersPage from '../pages/BuroRecords/ExclusiveOffers';
import CreditCardsPage from '../pages/BuroRecords/CreditCards';
// import CreditScorePage from '../pages/BuroRecords/CreditScore';
import "../utils/sidebar.css";
import * as urls from "../urls"; ///utils/urls
import { useCookies } from "react-cookie";
//import { getCookie } from "../../utils/common";
import {
  removeAllCookies,
  isCookieExpired,
  getCookiePathFromURL,
} from "../helpers";
// import {
//   getPipelines,
//   logOutApi,
// } from "../../api/services/PartnerPipelineDashboard";
// import { PARTNER_LOGOUT } from "../../utils/urls";
import { getCookie } from "../utils/common";
import { deleteAllCookies } from "../utils/common";

import { useState,useEffect } from 'react';


const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export const SideNavBar = () => {

  let domain = window.location.host.split(".")[0];
  if (window.location.host.includes("localhost")) {
    domain = "yoindi";
  }
  console.log("domain name", domain);

  const CookiePath = "/customers"
  console.log({CookiePath});
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [orgLogoData, setOrgLogoData] = useState(null);
  console.log("orgLogoData",orgLogoData)

  const [cookies, setCookie] = useCookies(["user"]);
  console.log("Cookies in CreditScore : ", cookies);
  
  const activeSlide = getCookie("lastSlide");
  console.log("activeSlide : ", activeSlide);

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    removeAllCookies(CookiePath);
    setAnchorEl(null);
    
  };

  const handleLogOut = () => {
    removeAllCookies(CookiePath);
    window.location.replace("/customers")
    setAnchorEl(null);
  };

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  //logout logic

//

////customersLogo Apis////
useEffect(() => {
  const apiUrl = `${process.env.REACT_APP_API_BASE_URL}${urls.CustomersLogo}`;
  const headers = {
    "Content-Type": "application/json",
    domain_name: domain,
  };

  fetch(apiUrl, {
    method: "GET",
    headers: headers,
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("org logo data", data?.data?.documents);
      setOrgLogoData(data?.data?.documents);
    })
    .catch((error) => {
      const { response } = error;
      console.log("org_error=>", { response, error });
      console.error(error);

      const { data } = response;

      props.updateAlertMsg({
        message:
          (data && data.message) ||
          "Something went wrong with organization Logo",
        messageType: "error",
      });
    });
}, []);
////

  const [selectedComponent, setSelectedComponent] = useState("Component 1");

  const handleButtonClick = (component) => {
      setSelectedComponent(component);
    };
    
    const renderComponent = () => {
      switch (selectedComponent) {
        case 'Component 1':
          return <CreditScorePage />;
          // return <CreditScoreCopy />;
        case 'Component 2':
          return <ExistingLoansPage />;
        case 'Component 3':
          return <ExclusiveOffersPage />;
        case 'Component 4':
          return <MyApplicationsPage />;
        case 'Component 5':
          return <CreditCardsPage />;  
        default:
          return null;
      }
    };

  return (
    <div
      className={`journeyRightSectionCredit ${
        activeSlide ? "fullScreenMobileViewCredit" : null
      }`}
    >
     
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <div
         
        >
      <AppBar position="fixed" className= "headerColor" open={open}>
        <Toolbar style={{display: "flex" }}>
          <IconButton
            color="
#2E3092"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <div 
          //className='TopNav'
          className={`slideHeaderCredit`}
          >
          <img className= "YoindiLogo" 
          //src={YoindiLogoSmall}
          src={`${process.env.REACT_APP_DOCUMENTS_BASE_URL}${orgLogoData}`} 
           />
        
        {auth && (
            <>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color=""
                style={{flexDirection: "column " }}
              >
                <AccountCircle color='blue'/>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                {/* <MenuItem onClick={handleClose}>Profile</MenuItem> */}
                <MenuItem onClick={handleLogOut}>Log Out </MenuItem>
              </Menu>
            </>
          )}
          </div>
          </Toolbar>
      </AppBar>
      </div>
      <div className='drawermob'>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          
            <ListItem disablePadding sx={{ display: 'block' }}>
              <ListItemButton
                 onClick={() => handleButtonClick('Component 1')}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                 <img src={CreditScoreIcon} alt="" />
                </ListItemIcon>
                <ListItemText primary="Credit Score" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>


              {/* <ListItemButton
                onClick={() => handleButtonClick('Component 2')}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                  <img src={ExistingLoansIcons} alt="" />
                </ListItemIcon>
                <ListItemText primary="Existing Loans" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>


              <ListItemButton
                onClick={() => handleButtonClick('Component 3')}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                 <img src={ExclusiveIcon} alt="" />
                </ListItemIcon>
                <ListItemText primary="Exclusive Offers" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>

              <ListItemButton
                onClick={() => handleButtonClick('Component 4')}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                 <img src={MyApplicationIcon} alt="" />
                </ListItemIcon>
                <ListItemText primary="My ApplicationsScore" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton>

              <ListItemButton
                onClick={() => handleButtonClick('Component 5')}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? 'initial' : 'center',
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : 'auto',
                    justifyContent: 'center',
                  }}
                >
                 <img src={CreditCardIcon} alt="" />
                </ListItemIcon>
                <ListItemText primary="Credit Cards" sx={{ opacity: open ? 1 : 0 }} />
              </ListItemButton> */}
              
              
              
            </ListItem>
          
        </List>
        
      </Drawer>
      </div>
      <div className={`journeyRightSectionCredit ${
        activeSlide ? "fullScreenMobileViewCredit" : null
      }`}>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <DrawerHeader />
        <Typography paragraph>
       
        <div className="wrapperCredit"> 
          {renderComponent()}
        </div>  
        
        </Typography>
      
      </Box>
      </div>
    </Box>
    
    </div>
  )
}
